<template>
  <div class="gx-modal" @click.self="close">
    <div class="gx-modal-box gx-ddb__box">
      <div class="gx-modal-head gx-modal-head--gray">
        <span class="gx-modal-title">店铺详情 · {{ shopName }}</span>
        <button class="gx-modal-close" @click="close">✕</button>
      </div>
      <div class="gx-modal-body gx-ddb__body">
        <!-- 时间筛选 -->
        <div class="gx-ddb__filter">
          <span class="gx-ddb__label">时间：</span>
          <span
            v-for="item in timeOptions"
            :key="item.id"
            class="gx-ddb__time-tag"
            :class="{ active: timeSelectId === item.id }"
            @click="timeTagClick(item)"
          >{{ item.name }}</span>
          <el-date-picker
            v-model="displayDateRange"
            type="daterange"
            range-separator="-"
            size="small"
            value-format="yyyy-MM-dd"
            start-placeholder="开始"
            end-placeholder="结束"
            :picker-options="datePickerOptions"
            style="width:220px;margin-left:10px;"
            @change="customDateChange"
          />
        </div>

        <!-- 一级标签 -->
        <div class="gx-ddb__main-tabs">
          <span class="gx-ddb__main-tab" :class="{ active: mainTab === 'transaction' }" @click="switchMainTab('transaction')">成交数据</span>
          <span class="gx-ddb__main-tab" :class="{ active: mainTab === 'refund' }" @click="switchMainTab('refund')">退款数据</span>
        </div>

        <!-- 二级标签 -->
        <div class="gx-ddb__sub-tabs">
          <span
            v-for="tab in currentSubTabs"
            :key="tab.key"
            class="gx-ddb__sub-tab"
            :class="{ active: subTab === tab.key }"
            @click="subTab = tab.key"
          >{{ tab.label }}</span>
        </div>

        <div v-loading="loading" class="gx-ddb__content">
          <!-- 筛选条件 -->
          <div v-if="getSectionFilters(subTab).length" class="gx-ddb__sub-filter">
<!--            <div v-if="getSectionFilters(subTab).includes('salesType')" class="gx-ddb__filter-row">-->
<!--              <span class="gx-ddb__label">售卖类型：</span>-->
<!--              <span-->
<!--                v-for="opt in salesTypeOptions"-->
<!--                :key="opt.value"-->
<!--                class="gx-ddb__time-tag"-->
<!--                :class="{ active: (sectionFilters[subTab] && sectionFilters[subTab].salesType) === opt.value }"-->
<!--                @click="setFilter(subTab, 'salesType', opt.value)"-->
<!--              >{{ opt.label }}</span>-->
<!--            </div>-->
            <div v-if="getSectionFilters(subTab).includes('carrier')" class="gx-ddb__filter-row">
              <span class="gx-ddb__label">载体：</span>
              <span
                v-for="opt in carrierOptions"
                :key="opt.value"
                class="gx-ddb__time-tag"
                :class="{ active: (sectionFilters[subTab] && sectionFilters[subTab].carrier) === opt.value }"
                @click="setFilter(subTab, 'carrier', opt.value)"
              >{{ opt.label }}</span>
            </div>
            <div v-if="getSectionFilters(subTab).includes('adTime')" class="gx-ddb__filter-row">
              <span class="gx-ddb__label">投放时段：</span>
              <span
                v-for="opt in adTimeOptions"
                :key="opt.value"
                class="gx-ddb__time-tag"
                :class="{ active: (sectionFilters[subTab] && sectionFilters[subTab].adTime) === opt.value }"
                @click="setFilter(subTab, 'adTime', opt.value)"
              >{{ opt.label }}</span>
            </div>
            <div class="gx-ddb__filter-foot">
              <button v-if="subTab === '1'" type="button" class="gx-ddb__config-btn" @click="openFieldConfig">指标配置</button>
            </div>
          </div>

          <!-- 卡片视图：成交概览 / 收支概况 -->
          <template v-if="isCardView">
            <div v-for="group in currentCardGroups" :key="group.name" class="gx-ddb__card-section">
              <div class="gx-ddb__card-section-head">
                <div class="gx-ddb__section-title">{{ group.name }}</div>
                <el-select
                  v-if="group.hasTimeSwitch"
                  v-model="refundTimeType"
                  size="small"
                  style="width:120px"
                >
                  <el-option label="支付时间" value="pay" />
                  <el-option label="退款时间" value="refund" />
                </el-select>
              </div>
              <div class="gx-ddb__cards">
                <template v-for="(field, index) in group.fields">
                  <div :key="field.key" class="gx-ddb__card">
                    <div class="gx-ddb__card-label">{{ field.label }}</div>
                    <div class="gx-ddb__card-value" :class="getValueClass(field, sectionCardData[field.key])">
                      {{ formatValue(field, sectionCardData[field.key]) }}
                    </div>
                  </div>
                  <div v-if="field.operator && index < group.fields.length - 1" :key="'op-' + field.key" class="gx-ddb__operator">{{ field.operator }}</div>
                </template>
              </div>
            </div>
          </template>

          <!-- 表格视图 -->
          <template v-else>
            <el-table :data="sectionData" border size="small" style="width:100%">
              <el-table-column
                v-for="col in currentColumns"
                :key="col.key"
                :prop="col.key"
                :label="col.label"
                :width="col.width"
                :min-width="col.minWidth || 100"
                :align="col.align || 'center'"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span :class="getValueClass(col, scope.row[col.key])">{{ formatValue(col, scope.row[col.key]) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>

    <!-- 指标配置（二层面板） -->
    <div v-if="showFieldConfig" class="gx-modal gx-ddb__config-modal" @click.self="onConfigClose">
      <div class="gx-modal-box gx-ddb__config-box">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">指标配置</span>
          <button class="gx-modal-close" @click="onConfigClose">✕</button>
        </div>
        <div class="gx-modal-body gx-ddb__cfg-body">
          <div v-for="group in overviewGroups" :key="group.name" class="gx-ddb__cfg-group">
            <div class="gx-ddb__cfg-group-title">
              <span>{{ group.name }}</span>
              <span class="gx-ddb__cfg-count">{{ group.fields.length ? getGroupCheckedCount(group) : 0 }}/{{ group.fields.length }}</span>
              <button class="gx-ddb__cfg-checkall" @click="toggleGroupAll(group)">{{ isGroupAllChecked(group) ? '取消全选' : '全选' }}</button>
            </div>
            <div class="gx-ddb__cfg-items">
              <label
                v-for="field in group.fields"
                :key="field.key"
                class="gx-ddb__cfg-item"
                :class="{ 'gx-ddb__cfg-item--on': tempSelectedFields.includes(field.key) }"
              >
                <input type="checkbox" :value="field.key" v-model="tempSelectedFields" />
                <span>{{ field.label }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="gx-modal-foot gx-modal-foot--gray">
          <button class="gx-modal-foot-btn" @click="onConfigClose">取消</button>
          <button class="gx-modal-foot-btn gx-ddb__cfg-confirm" @click="confirmFieldConfig">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const STORAGE_KEY = 'shop_board_detail_field_config'

// 成交数据子标签
const transactionSubTabs = [
  { key: '1', label: '成交概览' },
  { key: '4', label: '收支概况' },
  { key: '5', label: '整体构成' },
  { key: '6', label: '账号构成' },
  { key: '7', label: '终端构成' },
  { key: '8', label: '品类构成' },
  { key: '9', label: '商品构成' },
  { key: '10', label: '价格带构成' },
  { key: '11', label: '人群构成' }
]

// 退款数据子标签
const refundSubTabs = [
  { key: '12', label: '退款整体数据' },
  { key: '13', label: '退款构成' },
  { key: '14', label: '退款原因' },
  { key: '15', label: '退款商品' }
]

const cardSections = ['1', '4']

// 各子标签支持的筛选类型
const sectionFilterConfig = {
  '1': ['carrier', 'adTime'],
  '6': ['salesType']
}

// 成交概览卡片分组（文案与列表页指标配置一致）
const overviewGroups = [
  {
    name: '交易指标',
    fields: [
      { key: 'income_amt', label: '成交金额', fmt: 'money' },
      { key: 'pay_amt', label: '用户支付金额', fmt: 'money' },
      { key: 'refunded_pay_amt_pay_time', label: '退款后用户支付金额(支付时间)', fmt: 'money' },
      { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', fmt: 'money' },
      { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '退款后智能优惠券金额(支付时间)', fmt: 'money' },
      { key: 'pay_plat_cost_amt', label: '电商平台补贴金额', fmt: 'money' },
      { key: 'refund_pay_plat_cost_amt_pay_time', label: '退款后电商平台补贴金额(支付时间)', fmt: 'money' },
      { key: 'author_subsidy_amt', label: '达人补贴金额', fmt: 'money' },
      { key: 'deposit_pay_amt', label: '预售定金', fmt: 'money' },
      { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
      { key: 'pay_combo_cnt', label: '成交件数', fmt: 'num' },
      { key: 'per_pay_combo_price', label: '件单价', fmt: 'money' },
      { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
      { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
      { key: 'net_income_amt', label: '净成交金额', fmt: 'money' },
      { key: 'net_pay_cnt', label: '净成交订单量', fmt: 'num' }
    ]
  },
  {
    name: '退款指标',
    fields: [
      { key: 'refund_amt', label: '成交退款金额(退款时间)', fmt: 'money' },
      { key: 'rfndsuc_amt', label: '退款金额(退款时间)', fmt: 'money' },
      { key: 'refund_amt_pay_time', label: '成交退款金额(支付时间)', fmt: 'money' },
      { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money' },
      { key: 'refund_amt_rate', label: '退款率(支付时间)', fmt: 'rate' },
      { key: 'saling_refund_amt_rate_pay_time', label: '发货前退款率(支付时间)', fmt: 'rate' },
      { key: 'ship_refund_amt_rate_pay_time', label: '未收货退款率(支付时间)', fmt: 'rate' },
      { key: 'received_refund_amt_rate_pay_time', label: '已收货退款率(支付时间)', fmt: 'rate' },
      { key: 'received_return_good_amt_rate_pay_time', label: '已收货退货退款率(支付时间)', fmt: 'rate' },
      { key: 'refund_order_cnt', label: '退款订单数(退款时间)', fmt: 'num' },
      { key: 'refund_order_cnt_pay_time', label: '退款订单数(支付时间)', fmt: 'num' },
      { key: 'refund_amt_one_hour_pay_time', label: '1小时成交退款金额(支付时间)', fmt: 'money' },
      { key: 'refund_order_cnt_one_hour_pay_time', label: '1小时退款订单数(支付时间)', fmt: 'num' },
      { key: 'refund_amt_ratio_one_hour_pay_time', label: '1小时成交退款率(支付时间)', fmt: 'rate' }
    ]
  },
  {
    name: '流量指标',
    fields: [
      { key: 'product_show_ucnt', label: '商品曝光人数', fmt: 'bignum' },
      { key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
      { key: 'product_show_click_ucnt_ratio', label: '商品曝光-点击转化率(人数)', fmt: 'rate' },
      { key: 'product_click_pay_ucnt_ratio', label: '商品点击-成交转化率(人数)', fmt: 'rate' },
      { key: 'product_show_pay_ucnt_ratio', label: '商品曝光-成交转化率(人数)', fmt: 'rate' },
      { key: 'gpm', label: '千次曝光用户支付金额', fmt: 'money' },
      { key: 'product_show_cnt', label: '商品曝光次数', fmt: 'bignum' },
      { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum' },
      { key: 'product_show_click_cnt_ratio', label: '商品曝光-点击转化率(次数)', fmt: 'rate' },
      { key: 'product_click_pay_cnt_ratio', label: '商品点击-成交转化率(次数)', fmt: 'rate' },
      { key: 'product_show_pay_cnt_ratio', label: '商品曝光-成交转化率(次数)', fmt: 'rate' }
    ]
  }
]

// 收支概况卡片分组
const incomeExpenseCardGroups = [
  {
    name: '成交构成',
    fields: [
      { key: 'income_amt', label: '成交金额', fmt: 'money', operator: '=' },
      { key: 'pay_amt', label: '用户支付金额', fmt: 'money', operator: '+' },
      { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', fmt: 'money', operator: '+' },
      { key: 'pay_plat_cost_amt', label: '电商平台补贴金额', fmt: 'money', operator: '+' },
      { key: 'author_subsidy_amt', label: '达人补贴金额', fmt: 'money', operator: '-' },
      { key: 'deposit_pay_amt', label: '预售定金', fmt: 'money' }
    ]
  },
  {
    name: '退款构成',
    hasTimeSwitch: true,
    fields: [
      { key: 'refund_amt_pay_time', label: '成交退款金额', fmt: 'money', operator: '=' },
      { key: 'rfndsuc_amt_pay_time', label: '退款金额', fmt: 'money', operator: '+' },
      { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '智能优惠券退款', fmt: 'money', operator: '+' },
      { key: 'refund_pay_plat_cost_amt_pay_time', label: '平台补贴退款', fmt: 'money', operator: '+' },
      { key: 'refund_author_subsidy_amt_pay_time', label: '达人补贴退款', fmt: 'money' }
    ],
    fieldsRefundTime: [
      { key: 'refund_amt', label: '成交退款金额', fmt: 'money', operator: '=' },
      { key: 'rfndsuc_amt', label: '退款金额', fmt: 'money', operator: '+' },
      { key: 'refund_pay_qc_plat_cost_coupon_amt_pay_time', label: '智能优惠券退款+平台补贴退款', fmt: 'money', operator: '+' },
      { key: 'refund_author_subsidy_amt_refund_time', label: '达人补贴退款', fmt: 'money' }
    ]
  },
  {
    name: '支出构成',
    fields: [
      { key: 'amount_paid', label: '支出金额', fmt: 'money', operator: '=' },
      { key: 'qc_ad_amt', label: '投放消耗', fmt: 'money', operator: '+' },
      { key: 'pt_commission_amt', label: '平台佣金(结算口径)', fmt: 'money', operator: '+' },
      { key: 'author_commission_amt', label: '达人佣金(结算口径)', fmt: 'money' }
    ]
  },
  {
    name: '其他指标',
    fields: [
      { key: 'refund_pay_ucnt_ratio_pay_time', label: '退款率(支付时间)', fmt: 'rate' },
      { key: 'qc_ad_amt_ratio_n', label: '投放费比(剔除退款)', fmt: 'rate' }
    ]
  }
]

// 表格列定义
const tableColumnMap = {
  // 整体构成
  '5': [
    { key: 'sales_type', label: '自营/带货', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体类型', width: 90, fmt: 'text' },
    { key: 'channel_type', label: '账号/渠道', width: 100, fmt: 'text' },
    { key: 'douyin_account', label: '抖音号', width: 130, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'product_click_cnt', label: '商品点击次数', fmt: 'bignum', minWidth: 110 },
    { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率', fmt: 'rate', minWidth: 120 },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money', minWidth: 130 },
    { key: 'refund_amt_rate', label: '退款率(支付时间)', fmt: 'rate', minWidth: 120 }
  ],
  // 账号构成
  '6': [
    { key: 'account_name', label: '账号名称', width: 130, fmt: 'text' },
    { key: 'account_type', label: '账号类型', width: 90, fmt: 'text' },
    { key: 'sales_type', label: '自营/带货', width: 90, fmt: 'text' },
    { key: 'douyin_id', label: '抖音号', width: 130, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击-成交转化率', fmt: 'rate', minWidth: 120 },
    { key: 'live_pay_amt', label: '直播用户支付金额', fmt: 'money', minWidth: 130 },
    { key: 'video_pay_amt', label: '短视频用户支付金额', fmt: 'money', minWidth: 140 },
    { key: 'card_pay_amt', label: '商品卡用户支付金额', fmt: 'money', minWidth: 140 },
    { key: 'other_pay_amt', label: '其他用户支付金额', fmt: 'money', minWidth: 130 },
    { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money', minWidth: 130 },
    { key: 'rfndsuc_pay_time_rate', label: '退款率(支付时间)', fmt: 'rate', minWidth: 120 }
  ],
  // 终端构成
  '7': [
    { key: 'sales_type', label: '终端类型', width: 100, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' }
  ],
  // 品类构成
  '8': [
    { key: 'category_one_name', label: '一级类目', width: 100, fmt: 'text' },
    { key: 'category_two_name', label: '二级类目', width: 100, fmt: 'text' },
    { key: 'category_three_name', label: '三级类目', width: 90, fmt: 'text' },
    { key: 'category_four_name', label: '四级类目', width: 100, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'per_usr_pay_amt', label: '成交客单价', fmt: 'money', minWidth: 100 },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' },
    { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money', minWidth: 130 },
    { key: 'refund_amt_rate', label: '退款率(支付时间)', fmt: 'rate', minWidth: 120 }
  ],
  // 商品构成
  '9': [
    { key: 'product_name', label: '商品名称', width: 180, fmt: 'text', align: 'left' },
    { key: 'product_id', label: '商品编号', width: 120, fmt: 'text' },
    { key: 'product_carrier', label: '载体类型', width: 90, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'per_usr_pay_amt', label: '成交客单价', fmt: 'money', minWidth: 100 },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' },
    { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', fmt: 'money', minWidth: 130 },
    { key: 'refund_amt_rate', label: '退款率(支付时间)', fmt: 'rate', minWidth: 120 },
    { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_plat_cost_amt', label: '电商平台补贴金额', fmt: 'money', minWidth: 130 },
    { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '退款后智能优惠券金额(支付时间)', fmt: 'money', minWidth: 170 },
    { key: 'refund_pay_plat_cost_amt_pay_time', label: '退款后电商平台补贴金额(支付时间)', fmt: 'money', minWidth: 170 }
  ],
  // 价格带构成
  '10': [
    { key: 'pay_amt_interval', label: '价格区间', width: 120, fmt: 'text' },
    { key: 'pay_amt', label: '支付金额', fmt: 'money', minWidth: 120 },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'product_click_pay_cnt_ratio', label: '点击成交率', fmt: 'rate' }
  ],
  // 人群构成
  '11': [
    { key: 'customer_type', label: '人群类型', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体类型', width: 90, fmt: 'text' },
    { key: 'pay_amt', label: '用户支付金额', fmt: 'money', minWidth: 110 },
    { key: 'pay_ucnt', label: '成交人数', fmt: 'num' },
    { key: 'per_usr_pay_amt', label: '客单价', fmt: 'money' },
    { key: 'pay_cnt', label: '成交订单数', fmt: 'num' },
    { key: 're_pay_rate', label: '复购率', fmt: 'rate' }
  ],
  // 退款整体数据
  '12': [
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 90, fmt: 'text' },
    { key: 'all_refund_ucnt', label: '全部退款人数', fmt: 'num', minWidth: 110 },
    { key: 'all_refund_ocnt', label: '全部退款订单数', fmt: 'num', minWidth: 115 },
    { key: 'all_refund_amt', label: '全部退款金额', fmt: 'money', minWidth: 110 },
    { key: 'all_refund_rate', label: '全部退款率', fmt: 'rate', minWidth: 100 },
    { key: 'ship_before_refund_ucnt', label: '发货前退款人数', fmt: 'num', minWidth: 120 },
    { key: 'ship_before_refund_amt', label: '发货前退款金额', fmt: 'money', minWidth: 120 },
    { key: 'ship_after_noreceive_refund_ucnt', label: '未收货退款人数', fmt: 'num', minWidth: 120 },
    { key: 'ship_after_noreceive_refund_amt', label: '未收货退款金额', fmt: 'money', minWidth: 120 },
    { key: 'ship_after_receive_b_refund_ucnt', label: '已收货退款人数', fmt: 'num', minWidth: 120 },
    { key: 'ship_after_receive_b_refund_amt', label: '已收货退款金额', fmt: 'money', minWidth: 120 }
  ],
  // 退款构成
  '13': [
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 90, fmt: 'text' },
    { key: 'douyin_id', label: '抖音号ID', width: 130, fmt: 'text' },
    { key: 'douyin_name', label: '账号名称', width: 130, fmt: 'text' },
    { key: 'all_refund_top_reason', label: 'TOP退款原因', width: 150, fmt: 'text' },
    { key: 'all_refund_ucnt', label: '全部退款人数', fmt: 'num', minWidth: 110 },
    { key: 'all_refund_ocnt', label: '全部退款订单数', fmt: 'num', minWidth: 115 },
    { key: 'all_refund_amt', label: '全部退款金额', fmt: 'money', minWidth: 110 },
    { key: 'all_refund_rate', label: '全部退款率', fmt: 'rate', minWidth: 100 }
  ],
  // 退款原因
  '14': [
    { key: 'cause_type', label: '原因分类', width: 100, fmt: 'text' },
    { key: 'cause_msg', label: '具体原因', width: 150, fmt: 'text', align: 'left' },
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 90, fmt: 'text' },
    { key: 'all_refund_ucnt', label: '全部退款人数', fmt: 'num', minWidth: 110 },
    { key: 'all_refund_ocnt', label: '全部退款订单数', fmt: 'num', minWidth: 115 },
    { key: 'all_refund_amt', label: '全部退款金额', fmt: 'money', minWidth: 110 },
    { key: 'all_refund_rate', label: '全部退款率', fmt: 'rate', minWidth: 100 }
  ],
  // 退款商品
  '15': [
    { key: 'product_id', label: '商品ID', width: 120, fmt: 'text' },
    { key: 'product_name', label: '商品名称', width: 180, fmt: 'text', align: 'left' },
    { key: 'refund_path', label: '退款口径', width: 100, fmt: 'text' },
    { key: 'sales_type', label: '售卖类型', width: 90, fmt: 'text' },
    { key: 'carrier_type', label: '载体', width: 90, fmt: 'text' },
    { key: 'all_refund_ucnt', label: '全部退款人数', fmt: 'num', minWidth: 110 },
    { key: 'all_refund_ocnt', label: '全部退款订单数', fmt: 'num', minWidth: 115 },
    { key: 'all_refund_amt', label: '全部退款金额', fmt: 'money', minWidth: 110 },
    { key: 'all_refund_rate', label: '全部退款率', fmt: 'rate', minWidth: 100 }
  ]
}

export default {
  name: 'DouyinShopDetailModal',
  props: {
    shop: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      mainTab: 'transaction',
      subTab: '1',
      timeSelectId: 1,
      customDateRange: '',
      selectingStartDate: null,
      searchData: {
        start_time: '',
        end_time: ''
      },
      timeOptions: [
        { id: 1, name: '实时', day: 'realtime' },
        { id: 2, name: '近1天', day: '1' },
        { id: 3, name: '近7天', day: '7' },
        { id: 4, name: '近30天', day: '30' }
      ],
      datePickerOptions: {
        onPick: ({ minDate }) => {
          if (minDate) {
            this.selectingStartDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (time.getTime() > Date.now()) {
            return true
          }
          if (this.selectingStartDate) {
            const oneDay = 24 * 60 * 60 * 1000
            const maxDays = 31
            const minTime = this.selectingStartDate - maxDays * oneDay
            const maxTime = this.selectingStartDate + maxDays * oneDay
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return false
        }
      },
      sectionFilters: {
        '1': { carrier: '', adTime: '' },
        '6': { salesType: '' }
      },
      refundTimeType: 'pay',
      salesTypeOptions: [
        { value: '', label: '全店' },
        { value: '自营', label: '自营' },
        { value: '合作', label: '合作' }
      ],
      carrierOptions: [
        { value: '', label: '全部' },
        { value: '直播', label: '直播' },
        { value: '短视频', label: '短视频' },
        { value: '商品卡', label: '商品卡' },
        { value: '图文', label: '图文' },
        { value: '其他', label: '其他' }
      ],
      adTimeOptions: [
        { value: '', label: '不限' },
        { value: '全域投放时段', label: '全域投放时段' },
        { value: '标准+品牌投放', label: '标准+品牌投放' },
        { value: '非投放时段', label: '非投放时段' }
      ],
      apiData: {
        transaction_data: {},
        refund_data: {}
      },
      requestId: 0,
      overviewGroups,
      selectedFields: [],
      tempSelectedFields: [],
      showFieldConfig: false
    }
  },
  computed: {
    sectionData() {
      const source = this.mainTab === 'transaction' ? this.apiData.transaction_data : this.apiData.refund_data
      const section = source && source[this.subTab]
      if (!section) return []
      let data = Array.isArray(section) ? section : (Array.isArray(section.data) ? section.data : [])
      const filters = this.sectionFilters[this.subTab] || {}
      if (filters.salesType) data = data.filter(row => row.sales_type === filters.salesType)
      if (filters.carrier) data = data.filter(row => row.carrier_type === filters.carrier)
      if (filters.adTime) data = data.filter(row => row.qc_ad_time === filters.adTime)
      return data
    },
    sectionCardData() {
      return this.sectionData[0] || {}
    },
    shopName() {
      return this.shop.shop_name || ''
    },
    transactionSubTabs() {
      return transactionSubTabs
    },
    refundSubTabs() {
      return refundSubTabs
    },
    isRealtimeData() {
      return this.timeSelectId === 1
    },
    isCardView() {
      return cardSections.includes(this.subTab)
    },
    currentSubTabs() {
      return this.mainTab === 'transaction' ? transactionSubTabs : refundSubTabs
    },
    currentColumns() {
      return tableColumnMap[this.subTab] || []
    },
    currentCardGroups() {
      let groups
      if (this.subTab === '4') {
        groups = incomeExpenseCardGroups.map(group => {
          if (group.hasTimeSwitch) {
            return {
              ...group,
              fields: this.refundTimeType === 'pay' ? group.fields : group.fieldsRefundTime
            }
          }
          return group
        })
      } else {
        groups = overviewGroups
      }
      // 成交概览应用指标配置筛选
      if (this.subTab === '1' && this.selectedFields.length > 0) {
        groups = groups
          .map(group => ({
            ...group,
            fields: group.fields.filter(f => this.selectedFields.includes(f.key))
          }))
          .filter(group => group.fields.length > 0)
      }
      return groups
    },
    displayDateRange: {
      get() {
        if (this.customDateRange && this.customDateRange.length === 2) {
          return this.customDateRange
        }
        if (this.searchData.start_time && this.searchData.end_time) {
          return [this.searchData.start_time, this.searchData.end_time]
        }
        const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId)
        if (timeOption) {
          if (timeOption.day === 'realtime') {
            const today = this.formatDate(new Date())
            return [today, today]
          }
          const today = new Date()
          const days = parseInt(timeOption.day)
          const yesterday = new Date(today)
          yesterday.setDate(yesterday.getDate() - 1)
          const end = this.formatDate(yesterday)
          const start = new Date(yesterday)
          start.setDate(start.getDate() - (days - 1))
          return [this.formatDate(start), end]
        }
        return ''
      },
      set(value) {
        this.customDateRange = value
      }
    }
  },
  watch: {
    mainTab() {
      this.subTab = this.currentSubTabs[0] ? this.currentSubTabs[0].key : '1'
    }
  },
  created() {
    this.loadFieldConfig()
    this.loadData()
  },
  beforeDestroy() {
    this.requestId++
  },
  methods: {
    ...mapActions({
      getShopDataDetail: 'shop_board/getShopDataDetail'
    }),
    close() {
      this.requestId++
      this.$emit('close')
    },
    getSectionFilters(key) {
      return sectionFilterConfig[key] || []
    },
    setFilter(key, field, value) {
      if (!this.sectionFilters[key]) return
      this.sectionFilters[key][field] = value
    },
    switchMainTab(tab) {
      this.mainTab = tab
    },
    timeTagClick(item) {
      this.timeSelectId = item.id
      this.customDateRange = ''
      this.searchData.start_time = ''
      this.searchData.end_time = ''
      this.loadData()
    },
    customDateChange() {
      this.selectingStartDate = null
      if (this.customDateRange && this.customDateRange.length === 2) {
        const start = new Date(this.customDateRange[0])
        const end = new Date(this.customDateRange[1])
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24))
        if (diffDays > 31) {
          this.$message.warning('时间范围不能超过31天')
          this.customDateRange = ''
          return
        }
        this.timeSelectId = ''
        this.searchData.start_time = this.customDateRange[0]
        this.searchData.end_time = this.customDateRange[1]
      } else {
        this.timeSelectId = 1
        this.searchData.start_time = ''
        this.searchData.end_time = ''
      }
      this.loadData()
    },
    loadData() {
      const requestId = ++this.requestId
      this.apiData = { transaction_data: {}, refund_data: {} }
      this.loading = false
      const merShopId = this.shop.mer_shop_id || this.shop.shop_id
      if (!merShopId) return

      this.loading = true

      const params = { mer_shop_id: merShopId }
      if (this.searchData.start_time && this.searchData.end_time) {
        params.start_date = this.searchData.start_time
        params.end_date = this.searchData.end_time
      } else {
        const range = this.displayDateRange
        params.start_date = range[0]
        params.end_date = range[1]
        if (this.isRealtimeData) {
          params.is_realtime = 1
        }
      }

      this.getShopDataDetail({
        data: params,
        success: (res) => {
          if (requestId !== this.requestId) return
          this.loading = false
          if (res && res.code === 200) {
            this.apiData = res.data || { transaction_data: {}, refund_data: {} }
          } else {
            this.$message.error((res && (res.msg || res.message)) || '获取数据失败')
          }
        },
        error: () => {
          if (requestId !== this.requestId) return
          this.loading = false
          this.$message.error('获取数据失败，请重试')
        }
      })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatValue(field, val) {
      if (val === undefined || val === null || val === '') return '--'
      if (field.key === 'product_id') {
        return String(val)
      }
      if (field.fmt === 'text') return val
      if (field.fmt === 'money') {
        const n = Number(val)
        if (isNaN(n)) return val
        if (n >= 10000) return '¥' + (n / 10000).toFixed(2) + '万'
        return '¥' + n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
      if (field.fmt === 'num') {
        const n = Number(val)
        if (isNaN(n)) return val
        if (n >= 10000) return (n / 10000).toFixed(2) + '万'
        return n.toLocaleString('zh-CN')
      }
      if (field.fmt === 'bignum') {
        const n = Number(val)
        if (isNaN(n)) return val
        if (n >= 10000) return (n / 10000).toFixed(1) + '万'
        return n.toLocaleString('zh-CN')
      }
      if (field.fmt === 'rate') {
        const n = Number(val)
        if (isNaN(n)) return val
        return n.toFixed(2) + '%'
      }
      return val
    },
    getValueClass(field, val) {
      if (field.fmt === 'rate') {
        const n = parseFloat(val)
        if (!isNaN(n)) {
          if (n >= 10) return 'gx-ddb__rate gx-ddb__rate--high'
          if (n >= 5) return 'gx-ddb__rate gx-ddb__rate--mid'
        }
        return 'gx-ddb__rate'
      }
      return ''
    },
    // === 指标配置 ===
    loadFieldConfig() {
      let saved = localStorage.getItem(STORAGE_KEY)
      if (saved) {
        try {
          const parsed = JSON.parse(saved)
          this.selectedFields = Array.isArray(parsed) && parsed.length > 0 ? parsed : []
        } catch (e) {
          this.selectedFields = []
        }
      } else {
        this.selectedFields = []
      }
      this.tempSelectedFields = [...this.selectedFields]
    },
    openFieldConfig() {
      this.tempSelectedFields = [...this.selectedFields]
      this.showFieldConfig = true
    },
    onConfigClose() {
      this.tempSelectedFields = [...this.selectedFields]
      this.showFieldConfig = false
    },
    confirmFieldConfig() {
      this.selectedFields = [...this.tempSelectedFields]
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.selectedFields))
      this.sectionDataCache = {}
      this.showFieldConfig = false
    },
    getGroupCheckedCount(group) {
      return group.fields.filter(f => this.tempSelectedFields.includes(f.key)).length
    },
    isGroupAllChecked(group) {
      return group.fields.length > 0 && group.fields.every(f => this.tempSelectedFields.includes(f.key))
    },
    toggleGroupAll(group) {
      if (this.isGroupAllChecked(group)) {
        this.tempSelectedFields = this.tempSelectedFields.filter(k => !group.fields.some(f => f.key === k))
      } else {
        group.fields.forEach(f => {
          if (!this.tempSelectedFields.includes(f.key)) this.tempSelectedFields.push(f.key)
        })
      }
    }
  }
}
</script>

<style scoped>
.gx-ddb__box {
  max-width: 1000px;
  min-height: 100%;
}
.gx-ddb__body {
  padding: 14px 18px 20px;
}
.gx-ddb__filter,
.gx-ddb__filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.gx-ddb__filter-row + .gx-ddb__filter-row {
  margin-top: 8px;
}
.gx-ddb__label {
  color: #606266;
  font-size: 13px;
  margin-right: 6px;
}
.gx-ddb__time-tag {
  display: inline-block;
  padding: 2px 10px;
  margin-right: 6px;
  margin-bottom: 4px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  transition: all .2s;
  user-select: none;
  white-space: nowrap;
}
.gx-ddb__time-tag:hover {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F5;
}
.gx-ddb__time-tag.active {
  color: #fff;
  background: #C8443C;
  border-color: #C8443C;
}
.gx-ddb__main-tabs {
  display: flex;
  gap: 26px;
  margin-top: 14px;
}
.gx-ddb__main-tab {
  padding: 6px 2px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: all .2s;
  user-select: none;
}
.gx-ddb__main-tab:hover {
  color: #C8443C;
}
.gx-ddb__main-tab.active {
  color: #C8443C;
  font-weight: 600;
}
.gx-ddb__sub-tabs {
  display: inline-flex;
  flex-wrap: wrap;
  margin-top: 12px;
}
.gx-ddb__sub-tab {
  padding: 6px 18px;
  border: 1px solid #E4E7ED;
  border-left-width: 0;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  background: #fff;
  transition: all .2s;
  user-select: none;
  white-space: nowrap;
}
.gx-ddb__sub-tab:first-child {
  border-left-width: 1px;
  border-radius: 4px 0 0 4px;
}
.gx-ddb__sub-tab:last-child {
  border-radius: 0 4px 4px 0;
}
.gx-ddb__sub-tab:hover {
  color: #C8443C;
}
.gx-ddb__sub-tab.active {
  color: #C8443C;
  font-weight: 600;
}
.gx-ddb__filter-foot {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
.gx-ddb__config-btn {
  padding: 5px 14px;
  background: #fff;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: all .2s;
}
.gx-ddb__config-btn:hover {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F5;
}
.gx-ddb__content {
  min-height: 240px;
  padding-top: 14px;
}
.gx-ddb__sub-filter {
  margin-bottom: 12px;
}
.gx-ddb__section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.gx-ddb__card-section {
  margin-bottom: 18px;
}
.gx-ddb__card-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.gx-ddb__cards {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.gx-ddb__card {
  flex: 1 1 180px;
  max-width: 220px;
  min-width: 150px;
  background: #FAFBFC;
  border: 1px solid #EBEEF5;
  border-radius: 6px;
  padding: 10px 8px;
  text-align: center;
}
.gx-ddb__card-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-ddb__card-value {
  font-size: 17px;
  font-weight: 700;
  color: #303133;
}
.gx-ddb__operator {
  color: #909399;
  font-size: 15px;
  font-weight: 700;
}
.gx-ddb__rate {
  color: #303133;
}
.gx-ddb__rate--mid {
  color: #E6A23C;
}
.gx-ddb__rate--high {
  color: #C8443C;
}
/* 指标配置二层面板 */
.gx-ddb__config-modal {
  z-index: 800;
}
.gx-ddb__config-box {
  max-width: 620px;
}
.gx-ddb__cfg-body {
  max-height: 60vh;
}
.gx-ddb__cfg-group {
  border: 1px solid #EBEEF5;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 12px;
}
.gx-ddb__cfg-group-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.gx-ddb__cfg-count {
  color: #909399;
  font-weight: 400;
  font-size: 12px;
}
.gx-ddb__cfg-checkall {
  margin-left: auto;
  cursor: pointer;
  font-size: 12px;
  color: #C8443C;
  background: #FFF5F5;
  border: 1px solid #FFCCC7;
  border-radius: 4px;
  padding: 2px 10px;
}
.gx-ddb__cfg-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-ddb__cfg-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  user-select: none;
}
.gx-ddb__cfg-item--on {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F5;
}
.gx-ddb__cfg-item input {
  display: none;
}
.gx-ddb__cfg-confirm {
  background: #C8443C;
  border: none;
  color: #fff;
  font-weight: 600;
}
</style>
